"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFirebaseMessagingToken = void 0;
var tslib_1 = require("tslib");
var firebaseSdk_1 = require("./../../sdks/firebase/firebaseSdk");
var messaging_1 = require("firebase/messaging");
var getFirebaseMessagingToken = function (_a) { return tslib_1.__awaiter(void 0, [_a], void 0, function (_b) {
    var messagingSupported, requestResponse, permission, token;
    var _c;
    var askForPermission = _b.askForPermission;
    return tslib_1.__generator(this, function (_d) {
        switch (_d.label) {
            case 0: return [4 /*yield*/, (0, messaging_1.isSupported)()];
            case 1:
                messagingSupported = _d.sent();
                if (!(messagingSupported && typeof Notification !== 'undefined')) return [3 /*break*/, 5];
                if (!askForPermission) return [3 /*break*/, 3];
                return [4 /*yield*/, Notification.requestPermission()];
            case 2:
                requestResponse = _d.sent();
                permission = requestResponse || Notification.permission;
                if (permission !== 'granted') {
                    return [2 /*return*/, null];
                }
                _d.label = 3;
            case 3: return [4 /*yield*/, (0, messaging_1.getToken)((0, messaging_1.getMessaging)(), {
                    vapidKey: (_c = (0, firebaseSdk_1.firebaseSdkConfig)()) === null || _c === void 0 ? void 0 : _c.publicVapidKey,
                })];
            case 4:
                token = _d.sent();
                return [2 /*return*/, token];
            case 5: return [2 /*return*/, null];
        }
    });
}); };
exports.getFirebaseMessagingToken = getFirebaseMessagingToken;
